var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-15859.25 -24545.299 14.311 19.549",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 0.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_826092_cc",
    transform: "translate(-15880 -24555.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    transform: "translate(21 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    className: "cls-1",
    d: "M27.905,962.362a5,5,0,0,0-5,5v3.1h-.714A1.193,1.193,0,0,0,21,971.648v8.572a1.193,1.193,0,0,0,1.191,1.191H33.62a1.193,1.193,0,0,0,1.191-1.191v-8.572a1.193,1.193,0,0,0-1.191-1.191h-.714v-3.1A5,5,0,0,0,27.905,962.362Zm0,.476a4.509,4.509,0,0,1,4.524,4.524v3.1H23.381v-3.1A4.509,4.509,0,0,1,27.905,962.838Zm-5.715,8.1H33.62a.708.708,0,0,1,.714.714v8.572a.707.707,0,0,1-.714.714H22.191a.707.707,0,0,1-.714-.714v-8.572A.708.708,0,0,1,22.191,970.934Z",
    transform: "translate(-21 -962.362)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.2623b189.svg";
export { ForwardRef as ReactComponent };